import React from 'react';
import moment from 'moment';

function Footer() {
    return (
        <div className="pageFooter">
            <div className="loginPageFooterContainer">
                <div className="footerCopyright footerItem">
                    <a href='https://www.aon.com/en/'>Products & Services</a>
                    <a href='http://ir.aon.com/'>Investor Relations</a>
                    <a href='http://www.aon.com/about-aon/careers.jsp'>Careers</a>
                    <a href='https://www.aon.com/about-aon/privacy.jsp'>Privacy Policy</a>
                    <a href='http://www.aon.com/about-aon/cookies.jsp'>Cookie Notice</a>
                    <p>© {moment().format('YYYY')} Aon. All rights reserved.</p>
                </div>
                <div className="footerSocials footerItem">
                    <a className="iconfab-facebook" href='https://www.facebook.com/Aonplc/'></a>
                    <a className="iconfab-linkedin" href='https://www.linkedin.com/company/aon/'></a>
                    <a className="iconfab-twitter" href='https://twitter.com/aon_plc'></a>
                </div>
            </div>
        </div>
    );
}

export default Footer;
